import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedUiGraduationSelectModule } from '../lib/shared-ui-graduation-select.module'
import { GraduationSelectDocsComponent } from './graduation-select-docs/graduation-select-docs.component'
import { GraduationSelectExampleComponent } from './graduation-select-docs/graduation-select-example.component'


@NgModule({
  declarations: [
    GraduationSelectDocsComponent,
    GraduationSelectExampleComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedUiGraduationSelectModule
  ],
  exports: [
    GraduationSelectDocsComponent
  ]
})
export class SharedUiGraduationSelectDocsModule {}
